import {
  CREATE_SPARES_ISSUE_SUCCESS,
  FETCH_SPARES_ISSUE_SUCCESS,
  GET_ALL_UOM_SUCCESS,
  GET_JOB_CARD_IN_SPARES_ISSUE_SUCCESS,
  GET_LOCATION_IN_SPARES_ISSUE_SUCCESS,
  GET_QUANTITY_BY_SUB_LOCATION,
  GET_SPARES_ISSUE_SUCCESS,
  SAVE_SPARE_NAME_IN_SPARE_ISSUES,
  SAVE_SPARES_ISSUE_QUERY,
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
  location: [],
  jobCard: [],
  spareName: {},
  uomData: [],
  spareQty: [],
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_SPARES_ISSUE_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_SPARES_ISSUE_SUCCESS: {
      const query = {...state.query};
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      }
    }

    case CREATE_SPARES_ISSUE_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case GET_QUANTITY_BY_SUB_LOCATION: {
      return {
        ...state,
        spareQty: action.data,
      }
    }

    case GET_LOCATION_IN_SPARES_ISSUE_SUCCESS: {
      return {
        ...state,
        location: action.data,
      };
    }

    case GET_JOB_CARD_IN_SPARES_ISSUE_SUCCESS: {
      return {
        ...state,
        jobCard: action.data,
      };
    }

    case GET_ALL_UOM_SUCCESS: {
      return {
        ...state,
        uomData: action.data,
      };
    }

    case FETCH_SPARES_ISSUE_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }

    case SAVE_SPARE_NAME_IN_SPARE_ISSUES: {
      return {
        ...state,
        spareName: action.data,
      }
    }

    default:
      return state;
  }
}
